<template>
  <div class="l-content-inner">
    <!-- 회원가입 -->
    <div class="p-member-wrap">
      <div class="c-hgroup is-pc">
        <h1 class="c-title-level1">새로운 비밀번호로 로그인해주세요.</h1>
      </div>

      <form action="">
        <div class="id-pw-find type-password">
          <p class="find-result">
            <span class="text">새로운 비밀번호</span>
            <span class="text">
              <strong> {{ props.tmpPassword }}</strong>
            </span>
          </p>
        </div>

        <div class="c-list-group">
          <strong class="c-text-level2">안내사항</strong>
          <!-- 2024-12-10 문구 수정 -->
          <ul class="c-dot-list type-small">
            <li>
              임시 비밀번호는 보안을 위해 24시간 내에 변경해 주시기 바랍니다.
            </li>
            <li>
              로그인 후 [내정보 &gt; 회원정보관리]에서 안전한 비밀번호로
              변경하는 것을 권장드립니다.
            </li>
          </ul>
        </div>

        <div class="c-btn-area">
          <a href="#" class="c-button type-primary" @click.prevent="goToLogin">
            <span>로그인</span>
          </a>
        </div>
      </form>
    </div>
  </div>
</template>
<script setup name="idFindDomplete">
import { defineProps, onMounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const props = defineProps({
  tmpPassword: {
    type: String,
    required: true,
  },
});

onMounted(() => {});

const goToLogin = () => {
  router.push("/");
};
</script>
